const FAVICON_ASSETS: Record<string, { default: string }> = import.meta.glob(
	"../assets/sites/**/favicon.ico",
	{ eager: true, query: "?url" }
);
const LOGO_ASSETS: Record<string, { default: string }> = import.meta.glob(
	"../assets/sites/**/logo.png",
	{ eager: true, query: "?url" }
);
const FOOTER_LOGO_ASSETS: Record<string, { default: string }> = import.meta.glob(
	"../assets/sites/**/footer-logo.png",
	{ eager: true, query: "?url" }
);
const APP_ICON_ASSETS: Record<string, { default: string }> = import.meta.glob(
	"../assets/sites/**/icon.png",
	{ eager: true, query: "?url" }
);

const CSS_ASSETS: Record<string, { default: string }> = import.meta.glob(
	"../assets/sites/**/site.css",
	{ eager: true, query: "?url" }
);

export function getFavIconAssets(siteId: number) {
	const imagePath = `../assets/sites/${siteId}/favicon.ico`;
	const defaultPath = "../assets/sites/12/favicon.ico";
	return FAVICON_ASSETS[imagePath]?.default || FAVICON_ASSETS[defaultPath]?.default as string;
}
export function getLogoAssets(siteId: number) {
	const imagePath = `../assets/sites/${siteId}/logo.png`;
	const defaultPath = "../assets/sites/12/logo.png";
	return LOGO_ASSETS[imagePath]?.default || LOGO_ASSETS[defaultPath]?.default as string; // e.g., "/assets/sites/site-123/image-abc123.png"
}
export function getFooterLogoAssets(siteId: number) {
	const imagePath = `../assets/sites/${siteId}/footer-logo.png`;
	return FOOTER_LOGO_ASSETS[imagePath]?.default || getLogoAssets(siteId) as string; // e.g., "/assets/sites/site-123/image-abc123.png"
}
export function getIconAsset(siteId: number) {
	const imagePath = `../assets/sites/${siteId}/icon.png`;
	const defaultPath = "../assets/sites/12/icon.png";
	return APP_ICON_ASSETS[imagePath]?.default || APP_ICON_ASSETS[defaultPath]?.default as string; // e.g., "/assets/sites/site-123/image-abc123.png"
}
export function getCssAssets(siteId: number) {
	const cssPath = `../assets/sites/${siteId}/site.css`;
	const defaultPath = "../assets/sites/12/site.css";
	return CSS_ASSETS[cssPath]?.default || CSS_ASSETS[defaultPath]?.default as string
}
export function getSiteAssets(siteId: number) {
	const imagePath = `../assets/sites/${siteId}/logo.png`;
	const cssPath = `../assets/sites/${siteId}/site.css`;
	return {
		image: getLogoAssets(siteId),
		css: getCssAssets(siteId)
	};
}